import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
var route = [{
  path: '/newHome',
  name: 'newHome',
  component: function component() {
    return import('@/pages/home/newEntry');
  },
  meta: {
    name: i18n.tc("0")
  }
}, {
  path: '/home/serviceItem/:id/:service_type_id',
  name: 'ServiceItem',
  component: function component() {
    return import('@/pages/home/serviceItem');
  },
  props: function props(route) {
    return {
      id: route.params.id,
      service_type_id: route.params.service_type_id,
      title: route.query.title
    };
  },
  meta: {
    name: i18n.tc("146")
  }
}, {
  path: '/home/serviceDetails',
  name: 'ServiceDetail',
  component: function component() {
    return import('@/pages/home/serviceDetail');
  },
  props: function props(route) {
    return route.query;
  },
  meta: {
    name: i18n.tc("69")
  }
}, {
  path: '/home/appointment',
  name: 'Appointment',
  props: function props(route) {
    return route.query;
  },
  component: function component() {
    return import('@/pages/home/appointment');
  },
  meta: {
    name: i18n.tc("129")
  }
},
// {
//   path: '/AddClue',
//   name: 'AddClue',
//   component: () => import('@/pages/home/modal/AddClue'),
//   meta: {
//     name: '新增预约'
//   }
// },
{
  path: '/home/noticeList',
  name: 'NoticeList',
  component: function component() {
    return import('@/pages/home/noticeList/entry');
  },
  meta: {
    name: i18n.tc("147")
  }
}, {
  path: '/home/noticeDetail/:id',
  name: 'NoticeDetail',
  props: true,
  component: function component() {
    return import('@/pages/home/noticeList/detail');
  },
  meta: {
    name: i18n.tc("148")
  }
}, {
  path: '/customerproduct',
  name: 'CustomerProductList',
  component: function component() {
    return import('@/pages/product/customerProduct/index.vue');
  },
  meta: {
    name: i18n.tc("667")
  }
}, {
  path: '/customerproduct/detail/:cpId',
  name: 'CustomerProductDetail',
  props: true,
  component: function component() {
    return import('@/pages/product/customerProduct/detail.vue');
  },
  meta: {
    name: i18n.tc("667")
  }
}];
export default route;